var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-secondary",on:{"click":_vm.increaseFontSize}},[_c('b-icon',{attrs:{"icon":"zoom-in"}})],1),_c('button',{staticClass:"btn btn-secondary",on:{"click":_vm.decreaseFontSize}},[_c('b-icon',{attrs:{"icon":"zoom-out"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }